import {styled, TextField} from "@mui/material";

let ProximusTextField = styled(TextField)({
    width: '100%',
    paddingBottom: '20px',
    '& .MuiFilledInput-root': {
        backgroundColor: '#eaeaea',
        border: '2px solid transparent',
        borderRadius: '0.5rem'
    },
    '& .MuiFilledInput-root.Mui-focused': {
        backgroundColor: '#fff',
        borderColor: '#5C2D91'
    },
    '& .MuiFilledInput-root.Mui-error': {
        borderColor: '#b30000'
    },
    '& .MuiInputLabel-root.Mui-error': {
        color: '#b30000'
    },
    '& .MuiFormHelperText-root.Mui-error': {
        color: '#b30000'
    }
});

export default ProximusTextField;